import React, { useEffect, useState } from "react";
import axios from "axios";
import { format, parse } from "date-fns";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import AppFooter from "../../components/AppFooter";
import "primeicons/primeicons.css";
import { useParams } from "react-router-dom";
import { Document, Page, pdfjs } from "react-pdf";
import meupdf from "../../assets/notificacao/Notificacao_Extrajudicial.pdf";
import logoBranco from "../../assets/Pague_Direto_Marca-01.png";
import banner from "../../assets/meusboletos.png";

import QuickMenu from "../../components/QuickMenu";

import "./styles.scss"; // Import a CSS file for your component
import { Icons } from "react-toastify";

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

function Notifica() {
  const { valid } = useParams();

  const [numPages, setNumPages] = useState(null);
  const [password, setPassword] = useState("");
  const [correctPassword, setCorrectPassword] = useState(false);
  const [actionStatus, setActionStatus] = useState(null);
  const [dataNotificado, setDataNotificado] = useState("");
  const [zoom, setZoom] = useState(1); // Inicialmente, o zoom é 1 (100%)

  const [documento, setDocumento] = useState("");
  const [dataNascimento, setDataNascimento] = useState("");
  const [tokenConta, setTokenConta] = useState(null);
  const [cpfSemPontos, setCpfSemPontos] = useState(null);
  const [boletos, setBoletos] = useState([]);

  const [boletosBeneficiario1, setBoletosBeneficiario1] = useState([]);
  const [boletosBeneficiario2, setBoletosBeneficiario2] = useState([]);

  useEffect(() => {
    if (tokenConta && tokenConta !== null) {
      fetchBoletos(tokenConta, cpfSemPontos);
    }
  }, [tokenConta]);

  // useEffect(() => {
  //     carregaNotifica(1)
  // }, [])

  // useEffect(() => {
  //     if (actionStatus !== null) {
  //         enviaNofitica();
  //     }
  // }, [actionStatus]);

  function carregaNotifica(e) {
    // console.log(e)
    if (e === 1) {
      setActionStatus("Notificado_acesso");
    }
    if (e === 2) {
      setActionStatus("Notificado_aberto");
    }
  }

  // async function enviaNofitica() {
  //     try {
  //         // console.log(valid)
  //         const { data } = await Api.post(`/log/public/notificado`, {
  //             action: actionStatus,
  //             notifica_id: valid
  //         });
  //         // console.log(data)
  //         if (data.ls_action === 'Notificado_aberto') {
  //             // console.log('EitaPorra', data)
  //             setCorrectPassword(true);
  //         } else {
  //             // console.log("Notificado:", data)
  //         }
  //     } catch (error) {
  //         console.log(error);
  //         // toast.error("Erro ao acessar informações do usuário");
  //     }
  // }

  const filterBoletosByCurrentMonth = (boletos) => {
    const currentMonth = new Date().getMonth(); // Mês atual (0-11)

    return boletos.filter((boleto) => {
      const boletoMonth = parseInt(boleto.boleto_vencimento.substring(5, 7)) - 1; // Mês do boleto (0-11)
      return boletoMonth === currentMonth;
    });
  };

  function onDocumentLoadSuccess({ numPages }) {
    setNumPages(numPages);
  }

  const handleZoomIn = () => {
    setZoom(zoom + 0.1);
  };

  const handleZoomOut = () => {
    setZoom(Math.max(zoom - 0.1, 0.1)); // Impedir o zoom menor que 10%
  };

  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    setIsMobile(window.innerWidth <= 768); // Define a largura de tela abaixo da qual considera-se como mobile
    window.addEventListener("resize", handleResize); // Adiciona um listener para o evento resize
    return () => {
      window.removeEventListener("resize", handleResize); // Remove o listener ao desmontar o componente
    };
  }, []);

  const handleResize = () => {
    setIsMobile(window.innerWidth <= 768);
  };

  const renderPages = () => {
    const pages = [];
    for (let pageNumber = 1; pageNumber <= numPages; pageNumber++) {
      pages.push(
        <div className="pdf-page-container" key={`page_${pageNumber}`}>
          <Page
            className="pdf-page"
            pageNumber={pageNumber}
            renderTextLayer={false}
            renderAnnotationLayer={false}
            scale={isMobile ? 0.6 : zoom} // Reduz o zoom para 0.25 quando for mobile
          />
        </div>
      );
    }
    return pages;
  };

  const formatarDocumento = (documento) => {
    // Remove todos os caracteres não numéricos
    const documentoLimpo = documento.replace(/\D/g, "");

    // Limita o tamanho máximo para CNPJ
    const documentoFormatado = documentoLimpo.slice(0, 14);

    // Verifica se é um CPF ou CNPJ baseado no comprimento
    const isCpf = documentoFormatado.length <= 11;

    // Adiciona a formatação apropriada (CPF ou CNPJ)
    if (isCpf) {
      return documentoFormatado.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
    } else {
      return documentoFormatado.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, "$1.$2.$3/$4-$5");
    }
  };

  const formatarDataNascimento = (valor) => {
    // Remove todos os caracteres não numéricos
    const apenasDigitos = valor.replace(/\D/g, "");
    // Adiciona a pontuação à data de nascimento usando "/"
    const dataFormatada = apenasDigitos.replace(/(\d{2})(\d{2})(\d{4})/, "$1/$2/$3");

    return dataFormatada.substring(0, 10); // Limita a 10 caracteres para evitar que os pontos sejam adicionados no final
  };

  const renderBoletos = (boletos) => {
    const boletosMesAtual = boletos; // filterBoletosByCurrentMonth(boletos);

    if (boletosMesAtual.length > 0) {
      return boletosMesAtual.map((boleto) => (
        <div key={boleto.id} className="border-2 rounded-lg p-4 text-2xl bg-white mb-2">
          <button onClick={() => handleDownloadBoleto(boleto)}>
            {boleto.beneficiario && <p className="text-2xl text-sky-800 font-semibold">{boleto.beneficiario}</p>}
            <p className="text-xl text-stone-900 font-semibold">{boleto.rec_contratante_descricao}</p>
            <p className="text-xl text-stone-900 font-semibold">Vencimento: {boleto.boleto_vencimento_br}</p>
            <p className="text-xl text-stone-900 font-semibold">Valor: R$ {boleto.faturamento_valor}</p>
            <div>
              <h8 className="text-blue-800 font-extrabold">Baixar Boleto</h8>
            </div>
          </button>
        </div>
      ));
    } else {
      return (
        <div className="text-center">
          <div className="border-2 rounded-lg p-4 bg-white">
            <p className="text-2xl">Parece que não há boletos com seu nome vencendo neste mês.</p>
          </div>
          <p className="border-2 rounded-lg p-4 text-xl bg-white mt-2">
            Caso tenha alguma dúvida, entre em contato com o suporte usando o botão{" "}
            <b className="text-blue-900">Menu ≡</b>, localizado abaixo. ↴
          </p>
        </div>
      );
    }
  };

  const handleDownloadBoleto = async (boleto) => {
    try {
      // Faça a requisição para obter o base64_pdf
      const response = await axios.get(
        `https://api-recorrencia.paguedireto.com.br/boleto/${boleto.boleto_recorrencia_id}/pdf/`,
        {
          headers: {
            Authorization: `Bearer ${tokenConta}`,
          },
        }
      );

      const { base64_pdf } = response.data.dados;
      console.log(" OLha a dataa do boleto: ", response.data.dados);
      const nomeArquivo = `boleto_vencimento_${boleto.faturamento_vencimento}.pdf`;
      // Chame a função para baixar o PDF
      downloadPDF(base64_pdf, nomeArquivo);
    } catch (error) {
      console.error("Erro ao baixar o PDF:", error);
    }
  };

  const downloadPDF = (base64Data, fileName) => {
    const link = document.createElement("a");
    link.href = `data:application/pdf;base64,${base64Data}`;
    link.download = fileName;
    link.target = "_blank";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const fetchBoletos = async (token, documentos) => {
    try {
      // Fazer a solicitação à API para obter a lista de boletos usando o token
      const response = await axios.get(
        `https://api-recorrencia.paguedireto.com.br/boleto?usuario_documento=${documentos}&situacao=aguardando,vencido&limit=10&page=0`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      // console.log("O OS BOLETO", response.data.results)
      // console.log("O OS BOLETO", response.data.results.length)

      // Filtrar os boletos do mês atual
      const boletosMesAtual = response.data.boletos;

      // .filter((boleto) => {
      //     const boletoMonth = parseInt(boleto.boleto_vencimento.substring(5, 7)) - 1; // Mês do boleto (0-11)
      //     const currentMonth = new Date().getMonth(); // Mês atual (0-11)
      //     return boletoMonth === currentMonth;
      // });

      const boletosBeneficiario1 = boletosMesAtual.filter((boleto) => boleto.beneficiario === null); // Substitua "Beneficiario 1" pelo valor real
      const boletosBeneficiario2 = boletosMesAtual.filter((boleto) => boleto.beneficiario !== null); // Substitua "Beneficiario 2" pelo valor real

      if (boletosBeneficiario1.length === 0 && boletosBeneficiario2.length === 0) {
        console.log("SEM BOLETO");
        // setTokenConta(null)
        alert("Não localizamos um boleto pra você.");
      } else {
        console.log("COM BOLETO");
        // console.log("COM BOLETO 1", boletosBeneficiario1);
        // console.log("COM BOLETO 2", boletosBeneficiario2);
        setBoletosBeneficiario1(boletosBeneficiario1);
        setBoletosBeneficiario2(boletosBeneficiario2);
        carregaNotifica(2);
        setCorrectPassword(true);
      }
      // Atualizar o estado com a lista de boletos
    } catch (error) {
      console.error("Erro ao obter a lista de boletos:", error);
    }
  };

  const handleSubmit = async (event) => {
    // console.log("CHEGOU", documento, dataNascimento)

    event.preventDefault();
    try {
      const cpfSemPontos = documento.replace(/\D/g, ""); // Remove os pontos do CPF/CNPJ
      const dataSemBarras = dataNascimento.replace(/\D/g, ""); // Remove todos os caracteres não numéricos da data de nascimento
      if (dataSemBarras.length !== 8) {
        alert("Formato de data de nascimento inválido. Use o formato DD/MM/AAAA.");
        return;
      }
      const dataFormatada = format(parse(dataSemBarras, "ddMMyyyy", new Date()), "yyyy-MM-dd", {
        useAdditionalDayOfYearTokens: true,
      });

      const response = await axios.post("https://api.paguedireto.com.br/login/cliente", {
        cpf: cpfSemPontos,
        data_nascimento: dataFormatada,
      });

      if (response.data.token) {
        setCpfSemPontos(cpfSemPontos);
        setTokenConta(response.data.token);
        // await fetchBoletos(response.data.token, cpfSemPontos);
      } else {
        alert("Verifique os dados e tente novamente.");
      }
    } catch (error) {
      console.error("Erro ao fazer login:", error);
      alert("Ocorreu um erro, verifique seus dados");
    }
  };

  const handleDownloadPDF = () => {
    const link = document.createElement("a");
    link.href = meupdf; // URL do PDF
    link.target = "_blank";
    link.download = "Notificação.pdf"; // Nome do arquivo para download
    link.click();
  };

  return (
    <>
      <div
        style={
          correctPassword === false
            ? { display: "grid", gridTemplateRows: "1fr auto" }
            : { display: "grid", gridTemplateRows: "auto 1fr auto" }
        }
      >
        <div
          className={
            correctPassword === false ? "w-full h-full custom-div-notifica" : "w-full custom-div-notifica-logado"
          }
        >
          {correctPassword === false ? (
            <div className="grid md:flex md:items-center" style={{ height: "inherit" }}>
              <div className=" md:block hidden px-6 md:px-0 md:w-1/2 md:order-1" style={{ alignSelf: "end" }}>
                <img className="banner-image" src={banner} alt="cliente-logo" />
              </div>
              <div
                className="pdf-content self-center px-6 md:px-0 md:w-1/2 md:order-2"
                style={{ textAlign: "-webkit-center" }}
              >
                <div className="pdf-content">
                  <div className="pdf-info">
                    <h1 className="pdf-title">
                      Olá, <b className="font-tilt">bem-vindo(a)!</b>
                    </h1>
                    <h1 className="pdf-title">Acesse seus boletos com facilidade.</h1>
                  </div>
                  <div className="password-form">
                    <div className="password-label">
                      Preencha os campos abaixo com os dados do Responsável Financeiro:
                    </div>
                    <form onSubmit={handleSubmit}>
                      <div className="password-input w-[50%] mt-5">
                        <div className="password-label md:ml-2 font-bold">CPF / CNPJ</div>
                        <InputText
                          className="border-black border-2 w-full"
                          type="text"
                          value={formatarDocumento(documento)}
                          onChange={(e) => setDocumento(e.target.value)}
                          style={{ textAlign: "-webkit-center" }}
                        />
                      </div>
                      <div className="password-input w-[50%] mt-5">
                        <div className="password-label md:ml-2 font-bold">Data de Nascimento / Data de Abertura</div>

                        <InputText
                          className="border-black border-2 w-full"
                          type="dataNascimento"
                          value={formatarDataNascimento(dataNascimento)}
                          onChange={(e) => setDataNascimento(e.target.value)}
                          style={{ textAlign: "-webkit-center" }}
                        />
                      </div>
                      <div>
                        <button
                          className="password-submit-button mt-4 px-14 py-2 bg-blue-900 text-white text-base md:text-4xl font-bold"
                          type="submit"
                          style={{ borderRadius: 10 }}
                        >
                          Enviar
                        </button>
                      </div>
                      <div>
                        <img
                          className="w-6/12 mt-10"
                          src={logoBranco}
                          alt="cliente-logo"
                          // style={{ height: "80%" }}
                        />
                      </div>
                    </form>
                  </div>
                </div>
                <QuickMenu selected={false} />
              </div>
              <AppFooter />
            </div>
          ) : (
            <div className="w-full min-h-screen flex flex-col">
              <header className="flex p-4">
                <div className="fixed mt-[1vh] ml-[1vh] z-50 logoutBBtn top-0 left-2">
                  <Button
                    className=""
                    icon="pi pi-power-off"
                    onClick={() => {
                      setDocumento("");
                      setDataNascimento("");
                      setTokenConta(null);
                      setCpfSemPontos(null);
                      setBoletos([]);
                      setCorrectPassword(false);
                    }}
                    tooltip="Sair"
                    style={{ paddingLeft: 2 }}
                  >
                    {" "}
                    SAIR
                  </Button>
                </div>
                <div className="grid mt-12 md:mt-0 border-2 border-black rounded-xl mx-auto max-w-lg p-2 bg-slate-100">
                  <p className="text-xl text-slate-800 font-bold text-center">
                    Bem vindo(a),{" "}
                    <b className="text-blue-500">
                      {
                        // Verifica se há boletos em ambas as listas, exibindo o primeiro que tiver contrato_descricao
                        (boletosBeneficiario1.length > 0 && boletosBeneficiario1[0].usuario_nome) ||
                          (boletosBeneficiario2.length > 0 && boletosBeneficiario2[0].usuario_nome) ||
                          null // Se não houver boletos, exibe null (pode ser substituído por uma mensagem)
                      }
                    </b>
                  </p>
                </div>
              </header>
              <main className="flex-1 w-full flex flex-col items-center pb-12">
                {boletosBeneficiario1.length > 0 && (
                  <div className="mt-8 mx-0 md:mx-10">
                    <p className="text-3xl text-center font-semibold mb-6">Meus Boletos</p>
                    <div
                      className={`flex flex-wrap ${
                        boletosBeneficiario1.length === 1 ? "justify-center" : "justify-center lg:justify-start gap-8"
                      }`}
                    >
                      {renderBoletos(boletosBeneficiario1)}
                    </div>
                  </div>
                )}
                {boletosBeneficiario2.length > 0 && (
                  <div className="mt-8 mx-0 md:mx-10">
                    <p className="text-3xl text-center font-semibold mb-6"> Boletos - Beneficiário</p>
                    <div
                      className={`flex flex-wrap ${
                        boletosBeneficiario2.length === 1 ? "justify-center" : "justify-center lg:justify-start gap-8"
                      }`}
                    >
                      {renderBoletos(boletosBeneficiario2)}
                    </div>
                  </div>
                )}
                {boletosBeneficiario1.length === 0 && boletosBeneficiario2.length === 0 && (
                  <div className="text-center">
                    <div className="border-2 rounded-lg p-4 bg-white">
                      <p className="text-2xl">Parece que não há boletos com seu nome vencendo neste mês.</p>
                    </div>
                    <p className="border-2 rounded-lg p-4 text-xl bg-white mt-2">
                      Caso tenha alguma dúvida, entre em contato com o suporte usando o botão{" "}
                      <b className="text-blue-900">Menu ≡</b>, localizado abaixo. ↴
                    </p>
                  </div>
                )}
                <QuickMenu selected={false} />
              </main>
              <AppFooter />
            </div>
          )}
        </div>
      </div>
    </>
  );
}

export default Notifica;

// <div className="h-fit w-full custom-div-notifica">
//     <div className="pdf-document">
//         <div className={`pdf-controls ${isMobile ? 'w-full' : 'md:w-7/12'} place-content-center md:justify-around  sticky top-0 bg-white p-2`} style={{ zIndex: 100, borderBottomLeftRadius: 10, borderBottomRightRadius: 10 }}>
//             {!isMobile && (
//                 <Button className="p-button-rounded p-button-outlined pdf-button" onClick={handleZoomIn}>
//                     Zoom In
//                     <i className="pi pi-search-plus md:ml-2"></i>
//                 </Button>
//             )}
//             {!isMobile && (
//                 <Button className="p-button-rounded p-button-outlined pdf-button" onClick={handleZoomOut}>
//                     Zoom Out
//                     <i className="pi pi-search-minus md:ml-2"></i>
//                 </Button>
//             )}
//             {correctPassword && (
//                 <Button className="p-button-rounded p-button-outlined pdf-button" onClick={handleDownloadPDF}>
//                     Download PDF
//                     <i className="pi pi-download ml-2"></i>
//                 </Button>
//             )}
//         </div>
//         <div className="pdf-content" style={{ marginTop: '10px' }}>
//             <Document className="w-fit" file={meupdf} onLoadSuccess={onDocumentLoadSuccess}>
//                 {numPages && renderPages()}
//             </Document>
//         </div>
//     </div>
// </div>
